import React, { useState, useContext } from 'react';
import 'bulma/css/bulma.min.css';

import { BeamlineContext } from '../beamlineProvider.tsx';
import { SampleSetsContext } from '../sampleSetsProvider.tsx';


interface DeleteSetsProps {
  selection: string[];
}

const DeleteSets: React.FC<DeleteSetsProps> = (props) => {

  const beamlineContext = useContext(BeamlineContext);
  const sampleSetsContext = useContext(SampleSetsContext);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);


  function clickedOpen() {
    if (!inProgress && !isOpen && props.selection.length > 0) {
      setIsOpen(true);
    }
  }

  async function pressedSubmit() {
    setSubmitErrorMessage(null);
    setInProgress(true);

    var success = true;
    var index = 0;
    var failureMessage = null;
    while (index < props.selection.length && success) {
      const setSlug = props.selection[index];
      const result = await sampleSetsContext.sets.deleteSetFromServerAndRemove(setSlug);
      if (!result.success) {
        success = false;
        failureMessage = result.message || "";
      }
      index++;
    }

    sampleSetsContext.changed();

    setInProgress(false);
    if (!success) {
      setSubmitErrorMessage(failureMessage || "");
    } else {
      setIsOpen(false);
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  const plural = props.selection.length > 1 ? "s" : "";

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Delete { beamlineContext.setNounCapitalized }{ plural }

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Delete { beamlineContext.setNounCapitalized }{ plural }</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Are you sure you want to delete { props.selection.length } { beamlineContext.setNoun }{ plural }?
                All samples within will be deleted as well.
              </p>
            </div>
            <div className="block">
              <p>
                <b>This operation cannot be undone!</b>
              </p>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-danger"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Delete"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default DeleteSets
